import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField, CircularProgress } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
// import ConfigrationActions from "./ConfigrationActions";
import Custom_Paingation from "../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../utils/utils";
import { useSelector } from "react-redux";

function PublishUnPublishList() {
  const today = new Date().toISOString().split("T")[0];
  const [publishUnPublishList, setPublishUnPublishList] = useState({});
  const [roomNumbers, setRoomNumbers] = useState([]);
  const [cdsnList, setCdsnList] = useState('');
  const [confirmDeletePublishUnPublish, setConfirmDeletePublishUnPublish] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePublishUnPublishPopUp, setDeletePublishUnPublishPopUp] = useState(false);
  const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  const [editPublishUnPublish, setEditPublishUnPublish] = useState(false);
  const [editPublishUnPublishUpdate, setEditPublishUnPublishUpdate] = useState(false);
  const [createPublishUnPublishSuccessMsg, setCreatePublishUnPublishSuccessMsg] = useState('');
  const [publishUnPublishSid, setPublishUnPublishSid] = useState("");
  // const [hotelName, setHotelName] = useState('');
  const [flag, setFlag] = useState(false);
  const [guestNameOnBlur, setGuestNameOnBlur] = useState(false);
  const [apiWelcomeMessage, setApiWelcomeMessage] = useState("")
  const [loader, setLoader] = useState(false);
  const recordsPerPage = 10;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
    watch,
    setValue,
    clearErrors
  } = useForm({
    mode: 'onChange'
  });
  const { chainId } = useSelector((state) => state.chainIdReducer);

  let validPermissionClassName = isValidRole("WELCOME_MESSAGES_MODIFY")
    ? ""
    : "btn-disable-permission";

  const [selectedPage, setSelectedPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(1);
  const [paginationError, setPaginationError] = useState("")
  const [inputPageValue, setInputPageValue] = useState(1)

  const onSubmit = (data) => {

    let method = "POST";
    let url = `/create-welcome-message`;

    let payload = {
      ...data,
      // checkinDateTime: dayjs(data.checkinDateTime).format("DD/MM/YYYY"),
      // checkOutDateTime: dayjs(data.checkOutDateTime).format("DD/MM/YYYY"),
      isPublished: true
    }

    if (editPublishUnPublishUpdate) {
      method = "PUT"
      url = `/update-welcome-message`
      payload.id = publishUnPublishSid?.id
      payload.isPublished = false
    }
    setLoader(true);
    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({
          roomNo: '',
          cdsn: '',
          guestName: 'Guest',
          // checkinDateTime: '',
          // checkOutDateTime: '',
          welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
        });
        getAvailableRooms()
        setCreatePublishUnPublishSuccessMsg(response?.message);
        publishUnPublishListApi();
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  const onSave = (data) => {

    let method = "POST";
    let url = `/create-welcome-message`;

    let payload = {
      ...data,
      // checkinDateTime: dayjs(data.checkinDateTime).format("DD/MM/YYYY"),
      // checkOutDateTime: dayjs(data.checkOutDateTime).format("DD/MM/YYYY"),
      isPublished: false
    }
    setLoader(true);
    callAPI(url, method, payload, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({
          roomNo: '',
          cdsn: '',
          guestName: 'Guest',
          // checkinDateTime: '',
          // checkOutDateTime: '',
          welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
        });
        getAvailableRooms()
        setCreatePublishUnPublishSuccessMsg(response?.message);
        publishUnPublishListApi();
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  const isPublishUnPublishDeletedRef = useRef({
    isPublishUnPublishDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });


  const publishUnPublishPopUpHandler = (row) => {
    setPublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishModalData: {
        message: `Do you really want to ${row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}?`,
        row
      }
    };
    isPublishedUnPublishedRef.current = newModalRefData;
  }

  const deletePublishUnPublishPopUpHandler = (row) => {
    setDeletePublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPublishUnPublishDeletedRef.current = newModalRefData;
  }

  const deletePublishUnPublishHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePublishUnPublish === "") {
      return
    }

    if (confirmDeletePublishUnPublish === `Delete Room No ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message`) {
      setConfirmValidate(false)
      const { row } = isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData;
      setLoader(true);
      callAPI(`delete-welcome-message?Id=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPublishUnPublishDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPublishUnPublishDeletedRef.current = newModalRefData;
          publishUnPublishListApi();
          getAvailableRooms();
          setLoader(false);
        })
        .catch((error) => {
          console.warn(error);
          setLoader(false);
        });
    }
    reset({
      roomNo: '',
      cdsn: '',
      guestName: 'Guest',
      // checkinDateTime: '',
      // checkOutDateTime: '',
      welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("HOTEL_CHANNELS_MODIFY") ? <>
        {
          row?.isPublished.toLowerCase() !== 'published' ? <>
            <Tooltip title="Edit" arrow>
              <span>
                <MdModeEditOutline
                  className="edit-icon-enable"
                  onClick={() => { setPublishUnPublishSid(row); getPublishUnPublishListSidHandler(row) }}
                />
              </span>
            </Tooltip>
            <Tooltip title="Delete" arrow>
              <DeleteIcon
                className="delete-icon-enable"
                onClick={() => {
                  deletePublishUnPublishPopUpHandler(row);
                }}
              />
            </Tooltip>
          </> : <>
            <Tooltip title="Check-Out to perform actions">
              <span>
                <MdModeEditOutline className="edit-icon-disable" arrow />
              </span>
            </Tooltip>
            <Tooltip title="Check-Out to perform actions">
              <DeleteIcon className="delete-icon-disable" arrow />
            </Tooltip>
          </>
        }
        <Tooltip title={`${row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}`} className="cursor-pointer" arrow>
          <button
            type="button"
            className={`ms-3 ${row?.isPublished.toLowerCase() !== 'published' ? 'published' : 'un-published'}`}
            onClick={() => publishUnPublishPopUpHandler(row)}
          >
            {row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}
          </button>
        </Tooltip>
      </> :
        <>
          <Tooltip title="Don't have permission to edit">
            <span>
              <MdModeEditOutline className="edit-icon-disable" arrow />
            </span>
          </Tooltip>
          <Tooltip title="Don't have permission to delete">
            <DeleteIcon className="delete-icon-disable" arrow />
          </Tooltip>
          <Tooltip title="Don't have permission to delete" className="cursor-pointer" arrow>
            <span>
              <button
                type="button"
                className={`ms-3 ${row?.isPublished.toLowerCase() !== 'published' ? 'published' : 'un-published'} ${validPermissionClassName}`}
              // onClick={() => publishUnPublishPopUpHandler(row)}
              >
                {row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}
              </button>
            </span>
          </Tooltip>
        </>
    );
  };

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    { field: "roomNo", headerName: "Room No", flex: 1 },
    { field: "cdsn", headerName: "CDSN", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.cdsn.map((item, index) => <span>{index ? ', ' : ''}{item}</span>)}</p> },
    // { field: "checkinDateTime", headerName: "Check-in date", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.checkinDateTime).format("DD-MM-YYYY")}</p> },
    // { field: "checkoutDateTime", headerName: "Check-out date", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.checkoutDateTime).format("DD-MM-YYYY")}</p> },
    { field: "guestName", headerName: "Guest Name", flex: 1 },
    { field: "welcomeMessage", headerName: "Welcome Message", flex: 1, row: true, renderCell: (row) => <Tooltip title={row?.welcomeMessage}><p className={`mb-0 ${row?.welcomeMessage.length > 10 ? 'overflow-ellipsis' : ''}`}>{row?.welcomeMessage}</p></Tooltip> },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const publishUnPublishListApi = () => {
    setLoader(true);
    const apiPath = `/welcome-message?pageNo=${selectedPage}&recordsPerPage=${recordsPerPage}`;
    callAPI(apiPath, "POST", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setPublishUnPublishList(response)
        setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        setPaginationError("");
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  };

  useEffect(() => {
    publishUnPublishListApi();
  }, [selectedPage, chainId]);

  const getAvailableRooms = () => {
    callAPI("/available_rooms", "GET", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setRoomNumbers(res);
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }
  useEffect(() => {
    getAvailableRooms();
    cancelPublishUnPublishHandler();
    // const hotelName = JSON.parse(localStorage.getItem("userDetails"))?.chainIdHotelNameMapping?.filter((hotel) => hotel?.chainId === chainId?.chainId)
    // setHotelName(hotelName);
  }, [chainId]);

  useEffect(() => {
    ScrollToTop();
    if (watch("roomNo")) {
      callAPI(`getcdsn/room-no?roomNo=${watch("roomNo")}`, "GET", {}, { chainId: getChainIdLS() })
        .then((res) => {
          setCdsnList(res?.cdsn);
          setValue('cdsn', res?.cdsn);
        })
        .catch((err) => {
          console.warn(err.message);
        });
    } else {
      setCdsnList('');
    }
  }, [watch("roomNo"), chainId])

  const popupCloseHandler = () => {
    setDeletePublishUnPublishPopUp(false);
    setPublishUnPublishPopUp(false);
  };

  const getPublishUnPublishListSidHandler = (row) => {
    setLoader(true);
    callAPI(`/welcome-message?Id=${row?.id}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        // const checkinDateTime = new Date(response.checkinDateTime);
        // const checkoutDateTime = new Date(response.checkoutDateTime);
        const payload = {
          roomNo: response?.roomNo,
          cdsn: response?.cdsn,
          guestName: response?.guestName,
          // checkinDateTime: checkinDateTime.toISOString().split("T")[0],
          // checkOutDateTime: checkoutDateTime.toISOString().split("T")[0],
          welcomeMessage: response?.welcomeMessage
        };
        setApiWelcomeMessage(response?.welcomeMessage)
        reset(payload);
        setEditPublishUnPublishUpdate(true);
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  }

  const resetLayoutHandler = () => {
    reset({
      roomNo: '',
      cdsn: '',
      guestName: 'Guest',
      // checkinDateTime: '',
      // checkOutDateTime: '',
      welcomeMessage: `Dear ${watch('guestName')}, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
    });
  }

  const cancelPublishUnPublishHandler = () => {
    resetLayoutHandler()
    setEditPublishUnPublishUpdate(false);
    setPublishUnPublishSid('');
    setEditPublishUnPublish(false);
  }

  const publishUnPublishHandler = () => {
    setLoader(true);
    const apiPath = `/publish-unpublish-message?isPublish=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.isPublished.toLowerCase() !== 'published'}&Id=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.id}`;
    callAPI(apiPath, "POST", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setFlag(!flag)
        let successMessage = res.message
        const newModalRefData = {
          isPublishUnPublishModalData: {
            message: successMessage
          }
        };
        isPublishedUnPublishedRef.current = newModalRefData;
        publishUnPublishListApi();
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setPublishUnPublishPopUp(false);
        setLoader(false);
      });
  }

  // const validateCheckOutDate = (value) => {
  //   if (watch('checkinDateTime')) {
  //     const checkIn = new Date(watch('checkinDateTime'));
  //     const checkOut = new Date(value);
  //     if (checkIn >= checkOut) {
  //       return 'Check-out date must be after check-in date.';
  //     }
  //   }
  //   return true;
  // };

  //Pagination Handle changer
  const onPageChange = (event, value) => {
    setInputPageValue(value)
    setPaginationError("")
    setSelectedPage(value);
  };

  // useEffect(() => {
  //   if (editPublishUnPublish) {
  //     getPublishUnPublishListSidHandler();
  //     setEditPublishUnPublish(false);
  //   }
  //   ScrollToTop();
  //   setValue('guestName', 'Guest');
  // }, [editPublishUnPublish, chainId]);

  useEffect(() => {
    const firstHotelName = chainId?.navSelectedhotelName?.at(0)?.name;
    const updatedWelcomeMessage = watch('welcomeMessage').replace(/Dear.*?Welcome/, "Dear Welcome");
    clearErrors("welcomeMessage");
    
    if (!editPublishUnPublishUpdate) {
      if ( updatedWelcomeMessage === `Dear Welcome to ${firstHotelName}`) {
        setValue('welcomeMessage', `Dear ${watch('guestName')}, Welcome to ${firstHotelName}`);
      }
  
    } else {
      const splitApiMessage = apiWelcomeMessage?.replace(/Dear.*?Welcome/, "Dear Welcome");
      const isWelcomeMessageSame = `Dear Welcome to ${firstHotelName}` === splitApiMessage && updatedWelcomeMessage === `Dear Welcome to ${firstHotelName}`
      if (isWelcomeMessageSame) {
        setValue('welcomeMessage', `Dear ${watch('guestName')}, Welcome to ${firstHotelName}`);
      }
    }
  }, [watch('guestName'), watch("roomNo")]);

const resetWelcomeMessageHandler = () =>{
  setValue('welcomeMessage', `Dear ${watch('guestName')}, Welcome to ${chainId?.navSelectedhotelName[0]?.name}`)
  setApiWelcomeMessage(`Dear ${watch('guestName')}, Welcome to ${chainId?.navSelectedhotelName[0]?.name}`)
  clearErrors("welcomeMessage")
}

  return (
    <div className='row config-hotel'>
      <div className='col-12 left-column'>
         {loader && <div style={{zIndex: "99999"}} className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" className="hotel-list-form">
          <div className="row">
            <div className="left-column-header">
              <p>{editPublishUnPublishUpdate ? 'Edit Welcome Message Configuration' : "Welcome Message Configuration"}</p>
            </div>
            <div className="row pe-0">
              <div className="col-4">
                <div className="form-group-hotel">
                  <div className="floating-select-label">
                    <Controller
                      name="roomNo"
                      control={control}
                      rules={{
                        validate: (value) => (value !== undefined && value !== null && value !== '') || 'Please select room Number',
                      }}
                      render={({ field }) => (
                        <Autocomplete
                          {...field}
                          className={`multiselectlist ${field?.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                          disablePortal
                          options={roomNumbers}
                          getOptionLabel={(option) => option}
                          onChange={(_, newValue) => {
                            field.onChange(newValue);
                          }}
                          value={field.value || ''}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder=""
                              variant="outlined"
                              label="Select Room Number"
                              InputLabelProps={{
                                shrink: false,
                              }}
                            />
                          )}
                        />
                      )}
                    />
                  </div>
                  {errors.roomNo && (
                    <small className="required">{errors.roomNo?.message}</small>
                  )}
                </div>
                {/* <div className="row">
                  <div className="form-group-hotel col-6 mb-0">
                    <input
                      id="checkinDateTime"
                      type="date"
                      className="form-control"
                      min={today}
                      {...register("checkinDateTime", {
                        required: "Please Select Check In Date",
                      })}
                    />
                    {errors.checkinDateTime && (
                      <p className="required mb-0">{errors.checkinDateTime.message}</p>
                    )}
                  </div>
                  <div className="form-group-hotel col-6 mb-0">
                    <input
                      id="checkOutDateTime"
                      type="date"
                      className="form-control"
                      min={today}
                      {...register("checkOutDateTime", {
                        required: "Please Select Check Out Date",
                        validate: validateCheckOutDate
                      })}
                    />
                    {errors.checkOutDateTime && (
                      <p className="required mb-0">{errors.checkOutDateTime.message}</p>
                    )}
                  </div>
                </div> */}
              </div>

              {(watch("roomNo") !== "" && watch("roomNo") !== undefined && watch("roomNo") !== null) && <>
                <div className="form-group-hotel col-4">
                  <div className="floating-label">
                    <input
                      name="cdsn"
                      value={cdsnList}
                      disabled
                    />
                    <label htmlFor="cdsn">CDSN</label>
                  </div>
                </div>
                <div className="form-group-hotel col-4">
                  <div className={`floating-label`}>
                    <input
                      id="guestName"
                      maxLength={30}
                      placeholder=""
                      // value={`${watch('guestName')}`}
                      // onFocus={() => setGuestNameOnBlur(prev => !prev)}
                      {...register("guestName", {
                        required: "Enter Guest Name",
                        pattern: {
                          value: /^[a-zA-Z0-9. ]+$/,
                          message: "Only letters, numbers, spaces, and dots are allowed",
                        },
                        onChange: () => {
                          setGuestNameOnBlur(true);
                        },
                      })}
                    />
                    <label htmlFor="guestName">Enter Guest Name</label>
                  </div>
                  {errors.guestName && (
                    <small className="required">{errors.guestName.message}</small>
                  )}
                </div>
              </>}
              {(watch("roomNo") !== "" && watch("roomNo") !== undefined && watch("roomNo") !== null) && <div className="d-flex">
                <div className="col-8 mb-3">
                  <Controller
                    name="welcomeMessage"
                    control={control}
                    // defaultValue=""
                    rules={{ required: "Welcome Message is required" }}
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="welcomeMessage"
                        style={(watch("roomNo") !== "" && watch("roomNo") !== undefined && watch("roomNo") !== null) ? { height: '-webkit-fill-available' } : { height: '40px' }}
                        maxLength={60}
                        placeholder="Write a welcome message here..."
                      />
                    )}
                  />
                  {errors.welcomeMessage && <small className="required">{errors.welcomeMessage.message}</small>}
                </div>
                <div>
                  <button type="button" className="clear-btn ms-3" 
                  onClick={resetWelcomeMessageHandler}>Reset Message</button>
                </div>
              
              </div>}
              
            </div>
            <div className="col-12 text-end">
              {/* <div> */}
              <button type="button" className="clear-btn me-2" onClick={cancelPublishUnPublishHandler}>{editPublishUnPublishUpdate ? "Cancel" : "Clear All"}</button>
              {editPublishUnPublishUpdate && <>
                <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
              </>}
              {!editPublishUnPublishUpdate && <button type="button" disabled={isSubmitting} className={`disable-btn me-2 ${validPermissionClassName}`} onClick={handleSubmit(onSave)}>Save</button>}
              <button type="button" disabled={isSubmitting} className={`create-btn ${validPermissionClassName} `} onClick={handleSubmit(onSubmit)}>{editPublishUnPublishUpdate ? "Update" : "Check-In"}</button>
              {/* </div> */}
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Welcome Messages List</b></p>
          <TableWrapper
            data={publishUnPublishList?.welcomeMessageResponse}
            columns={columns}
            module="publish-unpublish"
            noPagination={true}
          />
          <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          />
        </div>
      </div>
      {/* <ConfigrationActions /> */}
      <BasicModal
        popupOpen={deletePublishUnPublishPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Welcome Message for Room No "<b>{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>Room No "{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo}" Welcome Message will be permanently deleted <br />
                Deleting the specified Room Welcome Message can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete Room No {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    // maxLength={40}
                    placeholder=''
                    onChange={(e) => setConfirmDeletePublishUnPublish(e.target.value)}
                  />
                  <label htmlFor="address">Delete Welcome Message</label>
                </div>
                {(confirmDeletePublishUnPublish === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Room No {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message</small></p>
                ) : (confirmDeletePublishUnPublish !== `Delete Room No ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete Room No {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.roomNo} Welcome Message</small></p>
                ) : ""
                }
              </div>
            </div> :
            isPublishUnPublishDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deletePublishUnPublishHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createPublishUnPublishSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPublishUnPublishSuccessMsg}</p>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePublishUnPublishSuccessMsg(''); setEditPublishUnPublishUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      <BasicModal
        popupOpen={publishUnPublishPopUp}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<>
          {isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData && <p className="mt-2">{isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message}</p>}
        </>
        }
        footer={
          isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Check-In?" ||
            isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Check-Out?" ? {
            primaryButton: {
              buttonName: "Cancel",
              action: popupCloseHandler
            },
            secondaryButton: {
              buttonName: isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out',
              action: publishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: popupCloseHandler
            }
          }
        }
      />
    </div>
  )
}

export default PublishUnPublishList;